/*@ngInject*/
const AlertRegistrationRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.performRegistration = function (channels, isUnsubscribe) {
        let url = '/rest/Alert/register',
            config = {
                params: {
                    registrationIdentifier: 'alert',
                    channels: channels
                }
            };

        if (isUnsubscribe) {
            return this.delete(url, config);
        } else {
            return this.post(url, {}, config);
        }
    };
};

angular.module('umCore')
    .service('alertRegistrationRepository', AlertRegistrationRepository);
